import { motion } from "framer-motion";
import { fadeInOut } from "./Animations";

export default function MenuOverlay({ extraClass = "" }) {
  return (
    <motion.div
      variants={fadeInOut}
      initial={"hidden"}
      animate={"visible"}
      exit="exit"
      key="menu-search-overlay"
      className={`menu-overlay fixed inset-0 top-40 bg-[#303337]/50 ${extraClass}`}
    ></motion.div>
  );
}
